(function ($) {
	$(window).scroll(() =>
		$('header').toggleClass('is-sticky', $(document).scrollTop() > 180)
	).trigger('resize');

	//Sticky the services menu too
	if ($('#main > #services-navigation').length) {
		$(window).scroll(() => {
			let header = document.querySelector('header').getBoundingClientRect();
			let hero = document.querySelector('.hero').getBoundingClientRect();

			//Toggle the sticky class for the desktop and mobile navigations
			if ($(document).scrollTop() > hero.height - header.height) {
				$('#services-navigation, #services-mobile-navigation').addClass('is-sticky');

				//Position the menus according to the header position
				$('#services-navigation, #services-mobile-navigation').attr('style', 'top: '+header.bottom+'px');
			}
			else {
				$('#services-navigation, #services-mobile-navigation').removeClass('is-sticky');

				$('#services-navigation, #services-mobile-navigation').attr('style', '');
			}

		});
	}

})(jQuery);
